import type { SisBundleStatus } from "@canvas-sync/shared";
import { variants } from "../lib/sisBundleStatus";

export function SisBundleStatusBadge({ status }: { status: SisBundleStatus }) {
  const v = variants[status];
  if (!v) return <span className="badge">{status}</span>;
  return (
    <span className={v.className}>
      {v.pulse && <span className="badge-pulse" />}
      {v.label}
    </span>
  );
}
